import { api } from "../api";

/**
 * workScheduleUpdateStatusById - Function that updates on database an existing work schedule status by id
 * /work-schedules/{id}/{status}
 * method PUT
 * @async-function
 */
const workScheduleUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/work-schedules/${id}/${status}`, {}, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default workScheduleUpdateStatusById;
